module.exports = __webpack_public_path__ + "static/img/shangbiao_09.308a9e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shangbiao_09.png
// module id = LIPP
// module chunks = 0